import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static controllerName = "school-navigation"

  connect() {
    this.updateActiveClass()
  }

  updateActiveClass() {
    const currentPath = window.location.pathname;
    this.linkTargets.forEach((link) => {
      const activePaths = link.dataset.activePaths
        ? JSON.parse(link.dataset.activePaths)
        : [new URL(link.href).pathname];
      const isActive = activePaths.some((path) => currentPath === path || currentPath.startsWith(path + "/"));
      link.classList.toggle("is-active", isActive);
    });
  }
  
}
